// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"c158fcb5","194":"66895eb2","196":"7c001596","293":"66bf503c","561":"dcc47154","861":"b192b958","981":"431dbce9"}[chunkId] + ".chunk.js";
};